import React, {TextareaHTMLAttributes} from 'react'
import {TextAreaContainer} from "./styles";
import {isValidString} from "../../utils";

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    value: string;
    helperText?: string;
    status?: 'danger' | 'warning' | 'success' | 'normal';
    label?: string;
}
export const TextArea = ({helperText, status = 'normal', label, value, ...textAreaProps}: TextAreaProps) => {
    return <TextAreaContainer status={status}>
            {isValidString(label) && <p>{label}</p>}
            <textarea value={value} {...textAreaProps}/>
            {isValidString(helperText) && <small>{helperText}</small>}
    </TextAreaContainer>
}
